import React from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import { Row, Col, Modal, Form } from 'react-bootstrap';
import { actions } from '../../redux/ProductReducer';
import { Field, reduxForm } from 'redux-form';
import { HorizontalFormControl, Button } from '../../../../common/components';
import SelectField from '../../../../common/components/ReduxFormField/SelectField';

const isRequired = (value) => {
  if (value === false) {
    return null;
  }
  return !value ? 'This field is required.' : null;
};

const EXCLUDE_INSURERS = ['FreeSpirit', 'Free2Travel', 'CPP', 'LIM', 'IPP', 'AIGPA'];

const CloneSchemeModalForm = ({
  insurerId,
  cloneInsurerSchemes,
  handleSubmit,
  submitting,
  onClose,
  onRefreshInsurerPage,
}) => {
  const { insurerList } = useSelector((state) => state.productManagement);

  const clone = (formValues) => {
    return Promise.resolve(cloneInsurerSchemes(insurerId, 'scheme', formValues)).then(
      () => {
        onRefreshInsurerPage();
        onClose();
      },
    );
  };

  const availableInsurers = insurerList.data.filter((availableInsurer) => {
    return (
      availableInsurer.id !== insurerId && !EXCLUDE_INSURERS.includes(availableInsurer.id)
    );
  });

  return (
    <Form horizontal onSubmit={handleSubmit(clone)}>
      <div>
        <Modal.Body>
          <h3>Clone Schemes</h3>
          <Row>
            <Col xs={12}>
              <Field
                name={'insurer'}
                label="Brand"
                labelSize={4}
                options={availableInsurers.map((availableInsurer) => {
                  return {
                    label: availableInsurer.attributes.name,
                    value: availableInsurer.id,
                  };
                })}
                component={SelectField}
                validate={[isRequired]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Field
                name={'attributes.name'}
                label="Scheme Name"
                labelSize={4}
                component={HorizontalFormControl}
                validate={[isRequired]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Field
                name={'attributes.prefix'}
                label="Prefix"
                labelSize={4}
                component={HorizontalFormControl}
                validate={[isRequired]}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Field
                name="data.relationships.channel_types"
                label="Channel Type"
                labelSize={4}
                component={SelectField}
                isMulti
                options={[
                  { label: 'B2Cs', value: 'B2C' },
                  { label: 'B2Bs', value: 'B2B' },
                  { label: 'Call Centre', value: 'DIR' },
                  { label: 'Aggregators', value: 'AGG' },
                ]}
                validate={[isRequired]}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-blue" type={'submit'} isLoading={submitting}>
            Create Schemes
          </Button>
          <Button className="pull-left" handleClick={onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </div>
    </Form>
  );
};

export default compose(
  connect(
    (state, props) => {
      return {
        initialValues: {
          attributes: {
            name: props.insurerName,
          },
        },
      };
    },
    {
      cloneInsurerSchemes: actions.cloneInsurerSchemes,
    },
  ),
  reduxForm({
    form: 'CloneSchemesForm',
  }),
)(CloneSchemeModalForm);
